import React, { useState } from "react";
import { ICreateSalesData, ICustomer } from "../../@types";
import { CloseIcon } from "../../assets/icons";
import SelectedMarkIcon from "../../assets/icons/SelectedIcon";
import { InvoiceErrors } from "../../modules/validateInvoiceForm";
import { Button } from "../common";
import PhoneInputComponent from "../common/PhoneInputComponent";
import { InputComponent } from "../core/Forms/InputComponent";
import CommunicationOptions from "./sections/communication";
import MarkAsPaidSection from "./sections/markPaid";
import AddModal from "./sections/modal/AddModal";
import PadLock from "../../assets/icons/PadLock";
import { useSubscription } from "../../context/SubscriptionProvider";
import { ShareOption } from "../Reusable/SendModal/ReusableSendModal";
// import {
//   checkSubscriptionV2,
//   hasPremiumSubscription,
// } from "../../utils/subscription";

interface CreateInvoiceProps {
  onCreateInvoice?: (event: any) => Promise<void>;
  onClose: () => void;
  formData: ICreateSalesData;
  validationResults: InvoiceErrors;
  handleMarkAsPaidChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handlePaymentDropDownChange: (name: string, value: string) => void;
  markAsPaid: boolean;
  handleSendEmailChange: (value: boolean) => void;
  shouldSendSMS: boolean;
  customer: ICustomer | null;
  sendEmail: boolean;
  handleshouldSendWhatsAppChange: (value: boolean) => void;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleshouldSendSMSChange: (value: boolean) => void;
  isLoading?: boolean;
  shouldSendWhatsApp: boolean;
}

const SendInvoiceModal: React.FC<CreateInvoiceProps> = ({
  onCreateInvoice,
  onClose,
  formData,
  handleMarkAsPaidChange,
  handlePaymentDropDownChange,
  validationResults,
  markAsPaid,
  handleSendEmailChange,
  shouldSendSMS,
  customer,
  sendEmail,
  handleshouldSendWhatsAppChange,
  shouldSendWhatsApp,
  handleInputChange,
  handleshouldSendSMSChange,
  isLoading,
}) => {
  const { hasSubscription } = useSubscription();
  const isEmailAvailable = customer?.email;
  const isPhoneAvailable = customer?.phone;

  const handleShouldSendEmailChange = (value: boolean) => {
    if (shouldSendSMS) {
      handleshouldSendSMSChange(!shouldSendSMS);
    }
    if (shouldSendWhatsApp) {
      handleshouldSendWhatsAppChange(!shouldSendWhatsApp);
    }
    handleSendEmailChange(value);
  };

  const handleWhatsAppChange = (value: boolean) => {
    if (sendEmail) {
      handleSendEmailChange(!sendEmail);
    }
    if (shouldSendSMS) {
      handleshouldSendSMSChange(!shouldSendSMS);
    }
    handleshouldSendWhatsAppChange(value);
  };

  const handleSMSChange = (value: boolean) => {
    if (sendEmail) {
      handleSendEmailChange(!sendEmail);
    }
    if (shouldSendWhatsApp) {
      handleshouldSendWhatsAppChange(!shouldSendWhatsApp);
    }
    handleshouldSendSMSChange(value);
  };

  const handlePhoneNumberChange = (phoneNumber: string) => {};

  const handleClose = () => {
    onClose && onClose();
  };
const [makingUpdate, setMakingUpdate] = useState(false);
const isLoadingState = (value: boolean) => {
  setMakingUpdate(value);
};

return (
  <AddModal showPadding={false}>
    <div className="mx-auto bg-white rounded-lg ">
      {/* Header */}
      <div className="flex justify-between items-center mb-4 px-5 pt-5">
        <h2 className="text-lg lg:text-[20px] font-semibold">Send Invoice</h2>
        <button
          className="text-gray-500 hover:text-gray-800"
          onClick={handleClose}
        >
          <CloseIcon />
        </button>
      </div>

      {/* Share Options */}
      <div className="px-5">
        <ShareOption
          enabled={sendEmail}
          hasPremium={true}
          main={customer?.email || ""}
          className=""
          onToggle={() => handleShouldSendEmailChange(!sendEmail)}
          title={"Share Via Email"}
          label="email"
          placeholder="Enter Customer Email Address"
          isLoadingState={isLoadingState}
          customerId={customer?.id}
        />
        <ShareOption
          enabled={shouldSendSMS}
          hasPremium={hasSubscription()}
          main={customer?.phone || ""}
          className=""
          onToggle={() => handleSMSChange(!shouldSendSMS)}
          title={"Share Via SMS"}
          warningText={"Upgrade your plan to access this feature"}
          label="phone"
          placeholder="Enter Customer Phone Number"
          isLoadingState={isLoadingState}
          customerId={customer?.id}
        />
        <ShareOption
          enabled={shouldSendWhatsApp}
          hasPremium={hasSubscription()}
          main={customer?.phone || ""}
          className=""
          onToggle={handleWhatsAppChange}
          title={"Share Via WhatsApp"}
          warningText={"Upgrade your plan to access this feature"}
          label="phone"
          placeholder="Enter Customer Phone Number"
          isLoadingState={isLoadingState}
          customerId={customer?.id}
        />
      </div>
      <hr className="mt-[1em] mb-1" />

      {/* Submit Button */}
      <MarkAsPaidSection
        markAsPaid={markAsPaid}
        handleMarkAsPaidChange={handleMarkAsPaidChange}
        formData={formData}
        validationResults={validationResults}
        handlePaymentDropDownChange={handlePaymentDropDownChange}
      />
      <hr className="mt-2" />
      <div className="flex px-5 pb-5 mt-[1em]">
        <Button
          text="Create Invoice"
          size="full"
          type="submit"
          isLoading={isLoading}
          disabled={
            isLoading || (markAsPaid && !formData.paymentMethod) || makingUpdate
          }
          onClick={onCreateInvoice}
          variant="secondary"
        />
      </div>
    </div>
  </AddModal>
);
};

export default SendInvoiceModal;
